import { Joi } from 'app-webtech-core/schemas';
import { actionCreator } from 'app-webtech-core/actions/actionCreator';
import { guideSelectNextIndexThunkAction as selectNextIndex } from './selectNextIndex';
import { SELECT_DOWN } from './types';
import { guidePropertiesSelector } from '../selectors/properties';

const payloadSchema = Joi.object().keys({
  index: Joi.number().required(),
});

const selectDownAction = actionCreator(SELECT_DOWN, payloadSchema);

export const guideSelectDownThunkAction = ({ updateInfo = true, autoPlay = true }) => async (
  dispatch,
  getState,
) => {
  await dispatch(selectNextIndex({ updateInfo, autoPlay }));
  const state = getState();
  const { selectedIndex } = guidePropertiesSelector(state);
  await dispatch(selectDownAction({ index: selectedIndex }));
};
